export default "__VITE_ASSET__B_k22mtY__"